import MainIdea from './main-idea';

export default MainIdea;
